import { render } from "./Why.vue?vue&type=template&id=127554c7&scoped=true"
import script from "./Why.vue?vue&type=script&lang=js"
export * from "./Why.vue?vue&type=script&lang=js"

import "./Why.vue?vue&type=style&index=0&id=127554c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-127554c7"

export default script